import { GET_USER } from "@/store/actionTypes";
import { GET_GLOBAL_TIME_PERIOD_FROM_STORAGE } from "@/modules/AuthModule/store/actionTypes";
import { GET_TIME_PERIODS_FROM_STORAGE } from "@/modules/AuthModule/store/actionTypes";
import { SET_GLOBAL_TIME_PERIOD } from "@/modules/AuthModule/store/mutationTypes";
import * as AT from "@/modules/DashboardModule/store/actionTypes";
import { GENERATE_CHECKLIST } from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/actionTypes";
import { SNACKBAR } from "@/store/actionTypes";
export default {
  methods: {
    generateChecklist(exportJob) {
      //           const exportJob = {
      //     id: this.$store.state.ExportModuleStore.exportJobId
      //   };
      this.isCheckListButtonLoading = true;
      this.$store
        .dispatch(GENERATE_CHECKLIST, { exportJobId: exportJob.id })
        .then(res => {
          window.open(res.path, "_blank");
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.isCheckListButtonLoading = false;
        });
    },
    getGlobalTimePeriod() {
      this.loading = true;
      this.isTimePeriodLoading = true;
      this.$store.dispatch(GET_GLOBAL_TIME_PERIOD_FROM_STORAGE).finally(() => {
        this.loading = false;
        this.isTimePeriodLoading = false;
      });
    },
    getTimePeriods() {
      this.loading = true;
      this.isTimePeriodLoading = true;
      this.$store.dispatch(GET_TIME_PERIODS_FROM_STORAGE).finally(() => {
        this.loading = false;
        this.isTimePeriodLoading = false;
      });
    },
    getUser() {
      this.loading = true;
      this.$store.dispatch(GET_USER).finally(() => (this.loading = false));
    },
    isNewOrEditingExportJob() {
      const exportJobId = this.$store.getters.exportJobId;
      if (this.$route.path.includes("new") || this.$route.path.includes(exportJobId)) {
        const errorMessage = "Cannot change TimePeriod in middle of Job";
        this.throwErrorMessage(errorMessage);
        return true;
      }
    },
    updateTimePeriod(newTimePeriodId) {
      const isNewOrEditingExportJob = this.isNewOrEditingExportJob();
      if (!isNewOrEditingExportJob) {
        this.loading = true;
        const formData = {
          id: newTimePeriodId
        };
        this.$store
          .dispatch(AT.UPDATE_TIME_PERIOD, formData)
          .catch(err => {
            this.handleError(err);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    setNavigationDrawer() {
      this.drawer = !this.drawer;
      this.$store.dispatch(AT.STORE_NAVIGATION_STATE, { drawer: this.drawer });
    },
    focusNext() {
      let allInputs = document.querySelectorAll("input[type='text']");
      var inputs = Array.from(allInputs);
      var index = 0;
      if (index < inputs.length) {
        inputs[index + 1].focus();
      }
    },
    handleError(err) {
      var errorMessage = this.getErrorMessage(err);
      this.throwErrorMessage(errorMessage);
      return;
    },
    throwErrorMessage(errorMessage) {
      this.$store.dispatch(SNACKBAR, {
        color: "error",
        text: `${errorMessage}`
      });
      return;
    },
    getErrorMessage(err) {
      var errorMessage = "";
      if (err.data) {
        errorMessage = err.data;
      }
      if (err.data.errors) {
        errorMessage = [].concat.apply([], Object.values(err.data.errors));
      }
      if (err.data.message) {
        errorMessage = err.data.message;
      }
      return errorMessage;
    },
    resetIconMessage() {
      return "This button will reset all the input fields on current page.";
    },
    getInvoiceFob() {
      const invoice = this.$store.state.ExportModuleStore.invoice;
      const invoiceValue = invoice.invoiceValue !== null ? parseFloat(invoice.invoiceValue) : 0;
      const freight = invoice.freightAmount !== null ? parseFloat(invoice.freightAmount) : 0;
      const insurance = invoice.insuranceAmount !== null ? parseFloat(invoice.insuranceAmount) : 0;
      const discount = invoice.discountAmount !== null ? parseFloat(invoice.discountAmount) : 0;
      return (invoiceValue - freight - insurance - discount).toFixed(2);
    },
    learnToUseDoc() {
      const url = "https://jiandanigaurav.gitbook.io/web-impex/";
      window.open(url, "_blank");
    }
  },
  computed: {
    userName() {
      return this.$store.state.AuthModuleStore.user.name;
    },
    timePeriods() {
      return this.$store.getters.timePeriods;
    },
    timePeriod: {
      get() {
        return this.$store.getters.globalTimePeriod;
      },
      set(value) {
        const isNewOrEditingExportJob = this.isNewOrEditingExportJob();
        if (!isNewOrEditingExportJob) {
          console.log("inside");
          this.$store.commit(SET_GLOBAL_TIME_PERIOD, value);
        }
      }
    },
    globalTimePeriodId() {
      return this.$store.getters.globalTimePeriod;
    },
    currentRouteName() {
      return this.$route.name;
    },
    navigationDrawer() {
      return this.$store.getters.navigationDrawer;
    },
    xlOrlg() {
      return this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl;
    },
    xsOrsm() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs;
    },
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    breakpointXs() {
      return this.$vuetify.breakpoint.xs;
    },
    breakpointMd() {
      return this.$vuetify.breakpoint.md;
    },
    breakpointSm() {
      return this.$vuetify.breakpoint.sm;
    },
    searchWidth() {
      switch (this.breakpoint) {
        case "xs":
          return "w-90";
        case "sm":
          return "w-80";
        case "md":
          return "w-75";
        case "lg":
          return "w-45";
        case "xl":
          return "w-45";
        default:
          return "w-75";
      }
    },
    containerWidth() {
      switch (this.breakpoint) {
        case "xs":
          return "w-90";
        case "sm":
          return "w-90";
        case "md":
          return "w-75";
        case "lg":
          return "w-75";
        case "xl":
          return "w-75";
        default:
          return "w-75";
      }
    },
    breakpointMargin() {
      switch (this.breakpoint) {
        case "xs":
          return "mt-4 mx-4";
        case "sm":
          return "mt-7 mx-7";
        case "md":
          return "mt-9 mx-9";
        case "lg":
          return "mt-11 mx-11";
        case "xl":
          return "mt-11 mx-11";
        default:
          return "w-75";
      }
    },
    appLogoVariant() {
      switch (this.breakpoint) {
        case "xs":
          return "x-medium";
        case "sm":
          return "x-medium";
        case "md":
          return "x-medium";
        default:
          return "x-medium";
      }
    }
  }
};
